import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { DocumentPaths } from '@models/collections';
import { OutlookAccount } from '@models/outlookAccount';
import { Repo } from '@repos/repo.service';

@Injectable({
	providedIn: 'root',
})
export class OutlookAccountsRepo extends Repo<OutlookAccount, unknown> {
	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}

	GetCollectionPath(userId: string): string {
		return DocumentPaths.outlookAccount(userId);
	}
}
